// Relaciona cada detalle con su petición principal. Los catálogos auxiliares y
// las acciones de escritura conservan su manejo de errores habitual.
const DETAIL_ROUTES = [
  [/^\/clientes\/([^/]+)\/detalles\/?$/, ['clients']],
  [/^\/productos\/([^/]+)\/detalles\/?$/, ['products']],
  [/^\/listas_de_precios\/([^/]+)\/?$/, ['price_lists']],
  [/^\/precios_especiales\/([^/]+)\/?$/, ['special_prices']],
  [/^\/promociones\/([^/]+)\/?$/, ['promos']],
  [/^\/pedidos\/([^/]+)\/?$/, ['orders']],
  [/^\/cotizaciones\/([^/]+)\/?$/, ['quotes']],
  [/^\/devoluciones\/([^/]+)\/?$/, ['refunds']],
  [
    /^\/(?:entregas|ventas_a_bordo)\/([^/]+)\/?$/,
    ['delivery_requests', 'delivery_receipts', 'delivery_receipts_onboard']
  ],
  [/^\/cobros\/([^/]+)\/?$/, ['charges']],
  [/^\/reporte_activos\/([^/]+)\/?$/, ['asset_activities']],
  [/^\/cierre_activos\/([^/]+)\/?$/, ['asset_collections']],
  [/^\/liquidaciones\/detalles\/([^/]+)\/?$/, ['settlements']],
  [/^\/facturas\/([^/]+)\/?$/, ['invoices']],
  [/^\/visitas-no-efectivas\/([^/]+)\/?$/, ['no_effective_visits']],
  [/^\/tareas_en_sitio\/([^/]+)\/?$/, ['pos_task_activities']],
  [/^\/ejecucion_punto_venta\/detalles\/([^/]+)\/?$/, ['pos_tasks']],
  [/^\/plan_de_visitas\/([^/]+)\/?$/, ['route_plans']],
  [/^\/usuarios\/([^/]+)\/?$/, ['ubiqua_app_users']],
  [/^\/ordenes_oc_details\/([^/]+)(?:\/[^/]+)?\/?$/, ['poc/orders', 'poc/purchase_orders']],
  [/^\/store_relations\/([^/]+)(?:\/edit)?\/?$/, ['poc/store_relations_overview']],
  [/^\/configuracion\/rbac\/usuarios\/([^/]+)\/?$/, ['rbac/users']],
  [/^\/configuracion\/rbac\/roles\/([^/]+)(?:\/editar)?\/?$/, ['rbac/roles']]
]

export const DETAIL_ACCESS_TITLE = 'Contenido no disponible'
export const DETAIL_ACCESS_MESSAGE = 'No tienes acceso a esta información.'

export function isMainDetailRequest(url, options, pageUrl) {
  if ((options.method || 'GET').toUpperCase() !== 'GET') return false
  try {
    const page = new URL(pageUrl)
    const request = new URL(url, page.origin)
    for (const [route, resources] of DETAIL_ROUTES) {
      const match = page.pathname.match(route)
      if (!match) continue
      const id = decodeURIComponent(match[1])
      if (['new', 'nuevo'].includes(id)) return false
      return resources.some((resource) => {
        const prefix = `/${resource}/`
        const position = request.pathname.lastIndexOf(prefix)
        if (position < 0) return false
        const requestId = request.pathname.slice(position + prefix.length).replace(/\/$/, '')
        return !requestId.includes('/') && decodeURIComponent(requestId) === id
      })
    }
    if (page.pathname === '/usuario_reportes') {
      const secondaryRequest =
        ['download', 'download_info_only', 'filter_info_only', 'card_info_only'].some(
          (key) => request.searchParams.get(key) === 'true'
        ) || request.searchParams.get('tab') === 'activity_filters'
      if (secondaryRequest) return false
      const user = page.searchParams.get('user_db_ref')
      return (
        Boolean(user) &&
        ((request.pathname.endsWith('/reports/ubiqua_app/user') &&
          request.searchParams.get('user_db_ref') === user) ||
          (request.pathname.endsWith('/reports/route_execution_user') &&
            request.searchParams.get('user_uid') === user))
      )
    }
    const assignedUsers = page.pathname.match(/^\/usuarios_asignados\/([^/]+)\/?$/)
    return (
      Boolean(assignedUsers) &&
      request.pathname.endsWith('/route_plans') &&
      request.searchParams.get('users_client_route') === 'true' &&
      request.searchParams.get('client_id') === decodeURIComponent(assignedUsers[1])
    )
  } catch {
    return false
  }
}

let snapshot = null
const listeners = new Set()
const update = (value) => {
  snapshot = value
  listeners.forEach((listener) => listener())
}

export const subscribeDetailAccess = (listener) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
export const getDetailAccess = () => snapshot
export const dismissDetailAccess = () => update(null)
export const clearDeniedDetailPath = () => {
  if (snapshot?.path) update({ ...snapshot, path: null })
}

export function denyDetailAccess(pageUrl) {
  // Una respuesta tardía de la pantalla anterior no debe sacar al usuario
  // de la pantalla a la que ya navegó.
  if (window.location.href !== pageUrl) return
  const page = new URL(pageUrl)
  const path = `${page.pathname}${page.search}`
  if (snapshot?.path !== path) update({ path, id: Date.now() })
}

export class DetailAccessError extends Error {
  constructor(status) {
    super(DETAIL_ACCESS_MESSAGE)
    this.name = 'DetailAccessError'
    this.status = status
  }
}
